module.exports = __webpack_public_path__ + "static/Headshot_BascomSmile-6c85298562ef8d44faca85b6317e12b6.jpg";